<template>
  <div>
    <div
      v-for="(appointDurationSlot, appointDurationSlotIndex) in appointDurationSlots"
      :key="appointDurationSlot.slotNumber"
    >
      <label class="label">ครั้งที่ {{ appointDurationSlot.slotNumber }}</label>
      <div>
         <label class="label-cost">ต้นทุน</label>
        <el-input
          class="input cost"
          type="text"
          inputmode="decimal"
          :value="getAppointCostInputValue(appointDurationSlot)"
          :placeholder="'บาท'"
          @input="handleAppointCostInput(appointDurationSlotIndex, $event)"
        ></el-input>
      </div>
      <!-- TODO: show Appointment Duration when ready on production -->
      <!-- <div class="d-flex input appointment-duration">
        <div class="default-duration">
          <el-radio
            v-model="appointDurationSlot.isDefaultDuration"
            :label="true"
            class="input mt-2"
          >เวลา Default</el-radio>
          <div
            class="input d-flex align-items-center"
            v-for="(duration, durationIndex) in appointDurationSlot.defaultDurations"
            :key="durationIndex"
          >
            <el-time-select
              v-model="duration.startAt"
              class="time-picker"
              disabled
            ></el-time-select>
            <p>-</p>
            <el-time-select
              v-model="duration.endAt"
              class="time-picker"
              disabled
            ></el-time-select>
          </div>
        </div>
        <div class="custom-duration">
          <el-radio
            v-model="appointDurationSlot.isDefaultDuration"
            :label="false"
            class="input mt-2"
          >กำหนดเอง</el-radio>
          <div
            class="input d-flex align-items-center"
            v-for="(duration, durationIndex) in appointDurationSlot.durations"
            :key="durationIndex"
          >
            <el-time-select
              v-model="duration.startAt"
              format="HH:mm"
              :picker-options="{
                start: '08:00',
                step: '01:00',
                end: '16:00',
                maxTime: duration.endAt
              }"
              placeholder="Start time"
              class="time-picker"
              :disabled="appointDurationSlot.isDefaultDuration"
            ></el-time-select>
            <p>-</p>
            <el-time-select
              v-model="duration.endAt"
              format="HH:mm"
              :picker-options="{
                start: '08:00',
                step: '01:00',
                end: '16:00',
                minTime: duration.startAt
              }"
              placeholder="End time"
              class="time-picker"
              :disabled="appointDurationSlot.isDefaultDuration"
            ></el-time-select>
            <i class="far fa-times-circle" @click="handleRemoveDuration(appointDurationSlot.slotNumber, durationIndex)"></i>
          </div>
          <el-button
            class="input button-new-duration"
            @click="handleAddDuration(appointDurationSlot.slotNumber)"
          >
            <i class="fas fa-plus"></i>
            เพิ่มเวลา
          </el-button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import {
  formatServicePriceInputValue,
  sanitizeServicePriceInput,
} from "../utils/servicePrice";

export default {
  components: {
    "el-input": Input,
  },
  props: ["value"],
  computed: {
    appointDurationSlots() {
      const {appointDurationSlots} = this.value;

      return appointDurationSlots;
    }
  },
  methods: {
    handleRemoveDuration(slotNumber, durationIndex) {
      this.$emit("removeDuration", { slotNumber, durationIndex });
    },
    handleAddDuration(slotNumber) {
      this.$emit("addDuration", slotNumber);
    },
    getAppointCostInputValue(appointDurationSlot) {
      return formatServicePriceInputValue(
        appointDurationSlot.appointCost,
        false
      );
    },
    handleAppointCostInput(appointDurationSlotIndex, cost) {
      const sanitizedCost = sanitizeServicePriceInput(cost);
      const appointDurationSlots = this.appointDurationSlots.map(
        (appointDurationSlot, index) =>
          appointDurationSlotIndex === index
            ? { ...appointDurationSlot, appointCost: sanitizedCost }
            : appointDurationSlot
      );

      this.$emit("input", { ...this.value, appointDurationSlots });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.input {
  margin-bottom: 20px;
  &.cost {
    margin-bottom: 10px;
    width: 120px;
  } ;
  .time-picker {
    width: 100%;
    margin: 5px;
  }

  .button-new-duration {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    width: 100%;
  }
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.appointment-duration {
  height: auto;
  width: 70%;
  border: 1px solid #dcdfe6;
  border-radius: $border-radius;

  .default-duration {
    width: 50%;
    padding: 15px;
  }

  .custom-duration {
    width: 50%;
    padding: 15px;
    border-left: 1px solid #dcdfe6;
  }
}

.fa-times-circle {
  cursor: pointer;
}

.label-cost {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: normal;
}
</style>
